import './github/diffs/blob-lines'
import './github/diffs/prose-diff'
import './github/diffs/linkable-line-number'

import './github/gist/gist-edit'
import './github/gist/task-lists'
import './github/gist/permalink-comments'
import {observe} from '@github-ui/selector-observer'
observe('.js-gist-dropzone', () => {
  import('./github/gist/drag-drop')
})
